export default __webpack_public_path__ + "static/kyrylo-93db27094d26c55a156bf6028df2e2b1.png";